import type { FeatureCollection, LayerManifest, SpatialFeature } from './types';

/**
 * Returns features with deterministic IDs without mutating provider-owned data.
 * Stable IDs are required by picking/highlighting APIs such as MapLibre feature state.
 */
export function getLayerFeatures(manifest: LayerManifest): SpatialFeature[] {
  const features = Array.isArray(manifest.data) ? manifest.data : manifest.data?.features ?? [];
  return features.map((feature, index) => {
    if (feature.id !== undefined && feature.id !== null && String(feature.id).length > 0) return feature;
    return { ...feature, id: createFeatureId(manifest.id, feature, index) };
  });
}

export function toLayerFeatureCollection(manifest: LayerManifest): FeatureCollection {
  return { type: 'FeatureCollection', features: getLayerFeatures(manifest) };
}

export function geometrySignature(collection: FeatureCollection): string {
  return [...new Set(collection.features.map((feature) => feature.geometry?.type ?? 'null'))].sort().join('|');
}

function createFeatureId(layerId: string, feature: SpatialFeature, index: number): string {
  const properties = feature.properties ?? {};
  const candidate = properties.id ?? properties.iso_a3 ?? properties.code ?? properties.name ?? properties.label;
  const token = candidate === undefined || candidate === null
    ? `feature-${index}`
    : String(candidate).trim().replace(/[^a-zA-Z0-9_.:-]+/g, '-').replace(/^-+|-+$/g, '') || `feature-${index}`;
  return `${layerId}:${token}:${index}`;
}
